'use client';

import React from 'react';
import { useAuthSession } from './AuthSessionProvider';

/**
 * Propiedades de RoleGuard
 * @param allowedRoles Lista de slugs permitidos para ver el contenido ('admin', 'editor', 'investigador')
 * @param children El contenido a proteger
 * @param fallback Componente o nulo que renderizar si el usuario no tiene permiso. Opcional.
 */
interface RoleGuardProps {
	allowedRoles: readonly string[];
	children: React.ReactNode;
	fallback?: React.ReactNode;
	loadingFallback?: React.ReactNode;
}

export function RoleGuard({
	allowedRoles,
	children,
	fallback = null,
	loadingFallback = null,
}: RoleGuardProps) {
	const { user, status } = useAuthSession();

	if (status === 'loading') {
		return <>{loadingFallback}</>;
	}

	if (!user || !allowedRoles.includes(user.role)) {
		return <>{fallback}</>;
	}

	return <>{children}</>;
}
